export const POS_PROMOTION_TYPE_STYLES = {
  bonus: { bg: '#FEF3C7', color: '#92400E', label: 'Bonus' },
  discount: { bg: '#DBEAFE', color: '#1D4ED8', label: 'Discount' },
  tp: { bg: '#D1FAE5', color: '#047857', label: 'Fixed (TP)' },
  percentage: { bg: '#EDE9FE', color: '#6D28D9', label: 'Percentage' },
}

export function getPromotionTypeLabel(type) {
  return POS_PROMOTION_TYPE_STYLES[type]?.label || type || 'Discount'
}

export function formatPromotionLabel(promo) {
  if (!promo) return ''
  const value = Number(promo.discount_value) || 0
  const unit = Number(promo.discount_unit) || 0
  switch (promo.type) {
    case 'bonus':
      return `Buy ${unit} get ${value} free`
    case 'discount':
      return `Flat Discount: ৳${value.toFixed(2)}`
    case 'tp':
      return `Promo Price: ৳${value.toFixed(2)}`
    case 'percentage':
      return `Flat ${value}% off`
    default:
      return `${value} / ${unit}`
  }
}

export function getPromotionTypeStyle(type) {
  return POS_PROMOTION_TYPE_STYLES[type] || POS_PROMOTION_TYPE_STYLES.discount
}
